var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticStyle:{"border-color":"orangered !important"},attrs:{"value":_vm.cellId,"prefix":"$","suffix":"","readonly":"","height":"24"}})}
var staticRenderFns = []

export { render, staticRenderFns }